module.exports = __webpack_public_path__ + "img/23_17.7ecdd8dd.png";